import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import "./assest/css/bootstrap/bootstrap.min.css";
import "./assest/css/open-iconic/font/css/open-iconic-bootstrap.min.css";
import "./assest/css/app.css";
import "./assest/font/Cairo/CairoFont.css";
import "./assest/font/MaterialDesign-Webfont-master/css/materialdesignicons.min.css";
import { TokenView } from "./models/views/identity/TokenView";
import Spinner from "./components/shared/spinner/Spinner";
import { ToastContainer } from "react-toastify";

// let token = 'valid token';
// axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
let access_token: TokenView = JSON.parse(
  localStorage.getItem("access_token") as string,
);

if (access_token !== null && access_token !== undefined) {
  axios.defaults.headers.common["Authorization"] =
    `Bearer ${access_token.accessToken}`;
}

function getApiBaseUrl() {
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes("student-stage")) {
    return "https://api-stage.barandehsaz.com";
  }

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:5100";
  }

  return "https://api.barandehsaz.ir";
}

axios.defaults.baseURL = getApiBaseUrl();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          bodyStyle={{ fontFamily: "Dana", textAlign: "right" }}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Spinner></Spinner>
        <App />
      </>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
